import React, { useContext, useEffect, useState } from 'react'
import { Check2Square, Square } from 'react-bootstrap-icons'
import Facility from '../../../../libs/api/services/Facility'
import CommonFunctionsContext from '../../../common/CommonFunctionsProvider'
import FacilityBreakdownComponent from './DetailsModal/FacilityBreakdownComponent'

const FacilitiesAdminContext = React.createContext()

const Layout = ({ children }) => {
    return (<>
        <div className="flex-shrink-1">
            <h3 className="text-center">Facility Management</h3>
        </div>
        <div className='p-3 flex-grow-1 d-flex flex-column h-100'>
            {children}
        </div>
    </>)
}

const FacilitiesAdminNavigation = () => {
    const { mode } = useContext(FacilitiesAdminContext)
    const MODES = {
        "Main Screen": {
            component: <MainScreen />
        },
        "Clone Configuration": {
            component: <CloneConfiguration />
        },
    }
    return (MODES[mode].component)
}

const FacilitiesAdminProvider = ({ children }) => {
    const [state, setState] = useState({
        mode: 'Main Screen'
    })

    const ChangeMode = (mode, options) =>
        setState({
            ...state,
            mode: mode,
            ...options
        })


    return (<FacilitiesAdminContext.Provider value={{
        mode: state.mode,
        ChangeMode,
        state
    }}>{children}</FacilitiesAdminContext.Provider>)
}

export default function FacilitiesAdmin() {

    return (
        <FacilitiesAdminProvider>
            <Layout>
                <FacilitiesAdminNavigation />
            </Layout>
        </FacilitiesAdminProvider>
    )
}

const MainScreen = () => {
    const { showConfirm, showError, GlobalRef, helpRefs } = useContext(CommonFunctionsContext)
    const { ChangeMode } = useContext(FacilitiesAdminContext)

    const _handleCloneFacilityResult = (result) => {
        showConfirm({
            onCancel: () => { },
            onConfirm: () => { },
            // layout: 'beeeg',
            title: 'Complete',
            heading: 'Clone Facility',
            children: <div>Facility has been cloned to {result.facility.facility}</div>,
            // <FacilityBreakdownComponent res={result} />,
            options: {
                'confirm': 'Ok',
                'cancel': undefined,
            }
        })
    }

    const _handleCloneFacility = (facility) => {
        showConfirm({
            onCancel: () => { },
            onConfirm: () => {
                Facility.CloneFacility(facility.id, helpRefs.current['FacilityManagementCloneNewName'].current.value)
                    .then(_handleCloneFacilityResult)
                    .catch(e => showError(e))
            },
            title: 'Please enter a name for the new facility',
            heading: 'Clone Facility',
            children: <div><p>Please enter a name for the new facility</p><input ref={r => GlobalRef(r, 'FacilityManagementCloneNewName')} className='form-control' placeholder={'New Facility Name'} /></div>,
            options: {
                'confirm': 'Continue',
                'cancel': 'Cancel',
            }
        })
    }

    const _handleCloneConfigurations = () => {
        // Select the configurations

        // Select the facilities to clone to
    }

    return (
        <FacilitySearch options={[
            {
                icon: undefined,
                description: 'Clone Entire Facility',
                reference: 'FacilityManagementCloneAllButton',
                action: _handleCloneFacility
            },
            // {
            //     icon: undefined,
            //     description: 'Clone Configurations',
            //     reference: 'FacilityManagementCloneConfigButton',
            //     action: (f) => ChangeMode('Clone Configuration', { facility: f })
            // },
        ]} />
    )
}

const CloneConfiguration = () => {
    const { ChangeMode } = useContext(FacilitiesAdminContext)
    return (<div className='d-flex flex-column h-100'
        style={{ maxHeight: '100%' }}
    >
        <div className='d-flex flex-grow-1' style={{ maxHeight: '95%' }}>
            <div className='w-100 d-flex flex-column'>
                <ConfigSelection />
            </div>
            <div className='w-100 d-flex flex-column' style={{ maxHeight: '95%' }}>
                <FacilitySearch multi />
            </div>
        </div>


        <div className='d-shrink-1 text-center'>
            <button onClick={() => ChangeMode('Main Screen')} className='btn'>Cancel</button>
            <button className='btn'>Next</button>
        </div>
    </div>)
}

const FacilitySearch = ({ options, multi }) => {
    const { GlobalRef, showConfirm, asyncLoader } = useContext(CommonFunctionsContext)
    const [facilitiesSrch, setFacilitiesSrch] = useState([])
    const [facilities, setFacilities] = useState([])
    const [selection, setSelection] = useState([])

    useEffect(() => {
        const load = async () => await asyncLoader(async () => {
            const res = await Facility.list()
            setFacilities(res)
            setFacilitiesSrch(res)
        })
        load()
    }, [])

    const _handleSearch = (search) =>
        setFacilitiesSrch(facilities.filter(x => x.facility.toLowerCase().includes(search.toLowerCase())))

    const _handleSelect = (id) => {
        var _sel = selection
        if (_sel.includes(id))
            _sel.splice(_sel.indexOf(id), 1)
        else
            _sel.push(id)
        setSelection([..._sel])
    }

    const _handleShowFacility = async (id) => {
        await asyncLoader(async () => {
            var res = await Facility.FacilityBreakdown(id)
            showConfirm({
                onCancel: () => { },
                onConfirm: () => { },
                layout: 'beeeg',
                title: 'Complete',
                heading: 'Facility Details',
                children: <FacilityBreakdownComponent res={res} />,
                options: {
                    'confirm': 'Ok',
                    'cancel': undefined,
                }
            })
        })
    }

    return (
        facilitiesSrch &&
        <div className={`d-flex flex-column h-100`}>

            <div className='flex-shrink-1'>
                <input ref={r => GlobalRef(r, 'FacilitySearch')} onChange={(e) => _handleSearch(e.target.value)} className='form-control' placeholder={'Search'} />
            </div>
            <div style={{ overflow: 'auto' }} className='flex-grow-1'>
                {
                    facilitiesSrch.map((f) => <div key={f.id} className={`d-flex ${selection.includes(f.id) ? 'bg-primary-container' : ''}`}>
                        {multi && <div onClick={() => _handleSelect(f.id)}>
                            {selection.includes(f.id) ? <Check2Square className='me-2' /> : <Square className='me-2' />}
                        </div>}
                        <div
                            onClick={e => _handleShowFacility(f.id)}
                            className='flex-grow-1'>{f.facility}</div>
                        {options && <div>
                            {options.map((o) => <button ref={r => o.reference ? GlobalRef(r, o.reference) : undefined} className='btn' onClick={() => o.action(f)}>{o.description}</button>)}
                        </div>}
                    </div>)
                }
            </div>
        </div>
    )
}

const ConfigSelection = ({ }) => {
    const { state } = useContext(FacilitiesAdminContext)
    const [breakdown, setBreakdown] = useState([])
    useEffect(() => {
        const load = async () => setBreakdown(await Facility.FacilityBreakdown(state.facility.id))
        load()
    }, [])

    if (!state.facility) return
    return (
        <div style={{ overflow: 'auto' }}>
            <div className='text-center'>{state.facility.facility}</div>
            <div>
                <ul className='list-unstyled'>
                    <li>Work Flows
                        <li>
                            <ul className='list-unstyled'>
                                {breakdown && breakdown.workFlows && breakdown.workFlows.map((w) => <li key={w.id} className='ms-2'><Check2Square className='me-2' />{w.name}</li>)}

                            </ul>
                        </li>
                    </li>
                    <li>Forms / Questionnaires</li>
                    <li>
                        <ul className='list-unstyled'>
                            {breakdown && breakdown.questionnaires && breakdown.questionnaires.map((w) => <li key={w.id} className='ms-2'><Check2Square className='me-2' />{w.name}</li>)}

                        </ul>
                    </li>
                    <li>To Do Lists</li>
                    <li>
                        <ul className='list-unstyled'>
                            {breakdown && breakdown.toDo && breakdown.toDo.map((w) => <li key={w.id} className='ms-2'><Check2Square className='me-2' />{w.list}</li>)}

                        </ul>
                    </li>
                    <li>Calendar Events</li>
                    <li>
                        <ul className='list-unstyled'>
                            {breakdown && breakdown.calendars && breakdown.calendars.map((w) => <li key={w.id} className='ms-2'><Check2Square className='me-2' />{w.eventName}</li>)}

                        </ul>
                    </li>
                </ul>
            </div>
        </div>

    )
}